module.exports = __webpack_public_path__ + "static/media/iconGrayGroup.8e7a5270.svg";